import React from 'react';

const WalkthroughContext = React.createContext();

export default WalkthroughContext;
